import Link from 'next/link';

import { StyledParagraph } from '@/components/LimitOrders/utils';

import { NATIVE_TOKEN_ADDRESS_PER_CHAIN_ID } from '@/constants/addresses';
import { CHAIN_IDS } from '@/constants/chain';

import { buttons } from '@/styles/buttons';
import { fontStyles } from '@/styles/typography';

import { tradeRoute } from '@/utils/url';

import { useMatchaWallets } from '../../../hooks/useMatchaWallets';
import { getConnectedChain } from '../../../utils/wallet';

export function MatchaAutoHero() {
  const { ethereumWallet } = useMatchaWallets();
  const chainId = getConnectedChain(ethereumWallet)?.id ?? CHAIN_IDS.MAINNET;

  return (
    <header className="grid relative mt-[152px] mb-[122px] tablet:mb-24 bg-[url(/images/matcha-auto/matcha-auto-hero.svg)] bg-no-repeat bg-position-[left_0%] bg-size-[1440px_238px] tablet:bg-position-[left_37%] tablet:bg-size-[100%_238px] desktop:bg-position-[center_35%] desktop:bg-size-[100%_238px]">
      <div
        className="pt-24 pb-[68px] tablet:pb-24 mx-auto tablet:mx-[26px] desktop:mx-auto z-[1] px-4 tablet:px-[84px] desktop:max-w-[992px] desktop:w-full desktop:ml-auto desktop:mr-auto"
        style={{
          background:
            'radial-gradient(50.13% 42.41% at 50% 52.44%, #FFF 0%, #FFF 29.69%, rgba(255, 255, 255, 0.64) 62.5%, rgba(255, 255, 255, 0.00) 100%)',
        }}
      >
        <h4
          className={fontStyles({
            variant: 'H2',
            class: [
              'text-500',
              'font-bold',
              'leading-14',
              'text-center',
              'text-token-green-1000',
              '[-webkit-text-fill-color:transparent]',
            ],
          })}
          style={{
            background:
              'linear-gradient(rgba(2, 168, 99, 1), rgba(2, 168, 99, 0.49)), linear-gradient(rgba(118, 182, 36, 1), rgba(36, 182, 77, 0))',
            backgroundClip: 'text',
          }}
        >
          Go gasless with Matcha.
        </h4>
        <h1
          className={fontStyles({
            variant: 'H1',
            class: [
              'text-center',
              'grid',
              'mb-6',
              'text-[46px]',
              'leading-12',
              'tablet:text-[64px]',
              'tablet:leading-[78px]',
            ],
          })}
        >
          Gasless swaps
        </h1>
        <StyledParagraph
          className={fontStyles({
            variant: 'BODY_LG',
            class: [
              'text-token-gray-800',
              'text-center',
              'grid',
              'mb-12',
              'mx-auto',
              'max-w-[460px]',
              'tablet:max-w-[31rem]',
            ],
          })}
        >
          Swap crypto without native tokens. Matcha handles the gas for swaps and approvals so you
          can focus on trading.
        </StyledParagraph>
        <div className="grid justify-center items-center">
          <Link
            href={tradeRoute({
              address: NATIVE_TOKEN_ADDRESS_PER_CHAIN_ID[chainId],
              chainId,
            })}
          >
            <div className={buttons({ size: 'medium', color: 'black', shape: 'pill' })}>
              Start trading
            </div>
          </Link>
        </div>
      </div>
    </header>
  );
}
